AttachmentHelpers = require('./helpers')
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
templates = require 'views/internal/templates'

module.exports = class AttachmentEditPopover extends View
  viewTitleKey: 'edit attachment'

  events:
    'click .js-edit-attachment': 'submit'

  submit: (e) =>
    Util.stop(e)

    { newName, nameShortened } = AttachmentHelpers.stripAndShortenName(
      @$('.js-attachment-name').val()
    )
    if nameShortened
      @$('.js-attachment-name').val(newName)

    newUrl = @$('.js-attachment-url').val()
    type = @model.getServiceKey()
    oldName = @model.get('name')
    oldUrl = @model.get('url')

    { newName, canUpdate } = AttachmentHelpers.validateUrlAndName(
      newUrl, newName, oldUrl, oldName, type
    )

    if canUpdate
      if type == 'other'
        @model.update({ url: newUrl, name: newName })
      else
        @model.update('name', newName)
      PopOver.hide()

  render: ->
    data = {}
    data.name = @model.get('name')
    data.url = @model.get('url')
    data.serviceKey = @model.getServiceKey()

    @$el.html(
      templates.fill(
        'edit_attachment',
        data
      )
    )

    @



// WEBPACK FOOTER //
// ./app/scripts/views/attachment/attachment-edit-popover.coffee